<div class="cart-container">
  <div class="cart-content" *ngIf="cartItems.length > 0; else emptyCart">
    <div class="cart-item" *ngFor="let item of cartItems">
      <div class="item-image">
        <img [src]="item.image" [alt]="item.name" *ngIf="item.image">
        <div class="no-image" *ngIf="!item.image">
          <span>📦</span>
        </div>
      </div>

      <div class="item-details">
        <h3 class="item-name">{{ item.name }}</h3>
        <p class="item-price">{{ formatPrice(item.price) }} c/u</p>
      </div>

      <div class="item-controls">
        <div class="quantity-controls">
          <button
            class="quantity-btn"
            (click)="decrementQuantity(item.id)">
            -
          </button>
          <span class="quantity">{{ item.quantity }}</span>
          <button
            class="quantity-btn"
            (click)="incrementQuantity(item.id)">
            +
          </button>
        </div>

        <div class="item-total">
          <span class="total-price">{{ formatPrice(item.totalPrice) }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="cart-header">
    <h2>Productos agregados</h2>
    <div class="cart-summary">
      <span class="total-items">{{ totalItems }} {{ totalItems === 1 ? 'item' : 'items' }}</span>
      <span class="total-price">{{ formatPrice(totalPrice) }}</span>
    </div>
  </div>

  <ng-template #emptyCart>
    <div class="empty-cart">
      <div class="empty-icon">🛒</div>
      <h3>Tu carrito está vacío</h3>
      <p>Agrega algunos productos para comenzar tu compra</p>
    </div>
  </ng-template>
</div>
